import * as React from 'react';
import {useDispatch} from 'react-redux';

import {OpenableModals} from '../../../openable-modals/openable-modals';
import * as actions from '../../../openable-modals/openable-modals-actions';

import {analyticsClient} from '../../../../analytics-client';

import {TrialSummaryActiveState} from './trial-summary-active-state';
import {TrialSummaryAddOns} from './trial-summary-add-ons';
import {TrialSummaryExpiredState} from './trial-summary-expired-state';

import styles from './trial-summary-page.module.css';

interface Props {
    daysLeftInTrial: number;
}

export function TrialSummaryPage(props: Props) {
    const dispatch = useDispatch();

    const isExpired = props.daysLeftInTrial === 0;

    const handleOpenCampaignsModal = () => {
        dispatch(actions.openModal(OpenableModals.CAMPAIGNS_ONBOARDING_MODAL));
    };

    React.useEffect(() => {
        analyticsClient.track(
            analyticsClient.EVENTS.TRACK_CUSTOMER_TRIAL_VISITS_BILLING_TRIAL_SUMMARY
        );
    }, []);

    return (
        <div className={styles.container}>
            {isExpired ? (
                <TrialSummaryExpiredState />
            ) : (
                <TrialSummaryActiveState daysLeftInTrial={props.daysLeftInTrial} />
            )}
            <TrialSummaryAddOns onOpenCampaignsModal={handleOpenCampaignsModal} />
        </div>
    );
}
